import React, { Component, useState } from "react";
import { assessmentActions, questionsActions, userActions } from "../../../../_actions";
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import { connect } from "react-redux";
import moment from "moment";
import PageTemplate from './ComponentReport/PageTemplate';
import EnergyAudit from './ComponentReport/EnergyAudit';
import DimensionScores from './ComponentReport/DimensionScores';
import BurnoutRed from './ComponentReport/BurnoutRed';
import PersonalAction from './ComponentReport/PersonalAction';
import DashboardUserLayout from "../../../AdminPanel/Dashboard/DashboardUserLayout"
import RadarChart from "./ComponentReport/RadarChart";
import { MdOutlineArrowBack } from "react-icons/md";

class EnergyProfileReport extends Component {
  constructor(props) {
    super(props);
    this.pdfExportComponent = React.createRef();
    this.state = {
      crrSelectedEmp: {
        "name": "Team Overall",
        "emp_id": ""
      }
    };
  }

  componentDidMount() {
    this.props.dispatch(questionsActions.emptyReducer());
    let type = this.props.match.params.id;

    if (type === "admin") {
      this.props.dispatch(assessmentActions.getAssessmentFlowEnergy({ code: this.props.match.params.idx }, "admin"));
    } else {
      this.props.dispatch(assessmentActions.getAssessmentFlowEnergy({ code: this.props.match.params.idx }));
    }
  }


  exportPDFWithComponent = () => {
    if (this.pdfExportComponent.current) {
      this.pdfExportComponent.current.save();
    }
  };

  handleSelectEmployee = (value) => {
    let { onAssessmentByEmpID, teamName } = this.props;
    let emp_id = "";
    if (value && value.employeeId) {
      emp_id = value.employeeId;
    }
    if (value) {
      this.setState({ crrSelectedEmp: { "emp_id": value.employeeId, "name": value.name } });
    } else {
      this.setState({ crrSelectedEmp: { "emp_id": "", "name": "Team Overall" } });
    }
    onAssessmentByEmpID(emp_id);
  }

  goBack = () => {
    this.props.history.push(`/assessment/useroverview`);
  }

  onLogout = () => {
    this.props.dispatch(userActions.logout());
  }

  render() {

    const { routeMenu } = this.state;
    let { questions, assessment, switchToAdmin, openAIBot } = this.props;
    let { getAssessmenrEmployeeDetailsData, getCoachUserSurveyListData } = questions;
    let { getAssessmentFlowEnergyData } = assessment;

    const getPeriod = () => {
      const hour = moment().hour(); // 0-23
      if (hour >= 5 && hour < 12) return "Morning";
      if (hour >= 12 && hour < 17) return "Afternoon";
      if (hour >= 17 && hour < 21) return "Evening";
      return "Night";
    };

    let userDetails = {
      name: getAssessmenrEmployeeDetailsData?.name ?? "Sample",
      email: getAssessmenrEmployeeDetailsData?.email ?? "",
      period: getPeriod()
    };


    let userName = userDetails?.name ?? "";

    let createdAt = moment()
      .utcOffset("+05:30")
      .format("DD MMMM, YYYY")
      ;


    let dimensionScores = getAssessmentFlowEnergyData && getAssessmentFlowEnergyData.scores && getAssessmentFlowEnergyData.scores.length > 0 ? getAssessmentFlowEnergyData.scores.map((ele) => ({ ...ele, dimension: ele.dimension.replace("Energy", "").trim() })) : [];

    console.log('dimensionScores---x->', dimensionScores)

    let getScores = (list, dimension) => {
      if (list && list.length > 0) {
        let item = list.find(ele => ele.dimension === dimension);
        return item ? item.sumScore : 0;
      } else {
        return 0;
      }
    };

    let getCategory = (score) => {
      let obj = {
        LABEL: "",
        TEXTCOLOR: "",
        CLASSCOLOR: "",
        TEXT: ""
      }
      if (score >= 38 && score <= 50) {
        obj["LABEL"] = 'High';
        obj["TEXTCOLOR"] = 'text-emerald-600';
        obj["COLORCLASS"] = 'bg-[#43A047]/10 text-[#43A047] border-[#43A047]/20'
        obj["TEXT"] = "Strong, sustainable capacity. An energy asset to protect and leverage."
      } else if (score >= 25 && score <= 37) {
        obj["LABEL"] = 'Moderate';
        obj["TEXTCOLOR"] = 'text-amber-500';
        obj["COLORCLASS"] = 'bg-[#FFA000]/10 text-[#FFA000] border-[#FFA000]/20'
        obj["TEXT"] = "Inconsistent capacity. The behaviours exist but are unreliable - clear growth potential."
      } else if (score >= 10 && score <= 24) {
        obj["LABEL"] = 'Low';
        obj["TEXTCOLOR"] = 'text-rose-500';
        obj["COLORCLASS"] = 'bg-[#E53935]/10 text-[#E53935] border-[#E53935]/20'
        obj["TEXT"] = "Depleted capacity. Performance and burnout risk in this dimension; treat as the priority."
      } else {
        obj["LABEL"] = 'N/A';
        obj["TEXTCOLOR"] = 'text-gray-400'
        obj["COLORCLASS"] = 'bg-gray-50 text-gray-500 border-gray-200'
      }
      return obj
    }


    const energyConfig = [
      {
        name: "Physical",
        barColor: "bg-sky-700",
        scoreColor: "text-sky-800",
        description: 'limited capacity; a performance and burnout risk in this dimension.'
      },
      {
        name: "Emotional",
        barColor: "bg-rose-700",
        scoreColor: "text-rose-800",
        description: 'limited capacity; a performance and burnout risk in this dimension.'
      },
      {
        name: "Mental",
        barColor: "bg-teal-600",
        scoreColor: "text-teal-700",
        description: 'limited capacity; a performance and burnout risk in this dimension.'
      },
      {
        name: "Spiritual",
        barColor: "bg-purple-700",
        scoreColor: "text-purple-800",
        description: 'limited capacity; a performance and burnout risk in this dimension.'
      }
    ];

    const scoreAllList = energyConfig.map(item => {
      const score = getScores(dimensionScores, item.name);
      const category = getCategory(score) || {};

      return {
        ...item,
        score: score ?? 0,
        maxScore: 50,
        status: category?.LABEL ?? "",
        text: category?.TEXT ?? "",
        statusColor: category?.TEXTCOLOR ?? "",
        colorClass: category?.COLORCLASS ?? ""
      };
    });

    return (
      <DashboardUserLayout
        showBot={false}
        openAIBot={openAIBot}
        userDetails={userDetails}
        onLogout={this.onLogout}
        switchToAdmin={switchToAdmin}>


        <div className="sticky top-0 z-20 flex flex-col items-center justify-between gap-4 py-4 px-10 bg-white border-b md:flex-row"  >
          <div className="flex items-center space-x-3">
            <div className="bg-white hover:text-[#1976D2] text-gray-500 border border-[#D1D5DB] hover:border-[#1976D2] p-1.5 rounded-full cursor-pointer" onClick={() => this.goBack()}>
              <MdOutlineArrowBack size={26} className="inline-block" />
            </div>
            <h1 className="font-semibold md:text-xl text-lg line-clamp-1 text-[#3D405B]">Energy Profile Report</h1>
          </div>
          <div className='flex items-center space-x-4'>
            <button onClick={() => { this.exportPDFWithComponent(); }} className="flex-1 uppercase text-sm font-medium rounded-md flex items-center justify-center gap-2 px-5 py-3 cursor-pointer bg-[#2196f3] hover:bg-[#1976d2] text-white transition-all duration-200">
              <span className="material-symbols-outlined text-lg">file_download</span>Download Report</button>
          </div>
        </div>

        <div className='max-w-4xl mx-auto my-4 bg-white shadow-sm border min-h-screen flex flex-col justify-between'>
          <div className=''>
            <PDFExport ref={this.pdfExportComponent}
              pageTemplate={(pageObj) => <PageTemplate pageNum={pageObj.pageNum} />}
              scale={0.6}
              forcePageBreak=".page-break"
              paperSize="A4"
              margin={0}
              fileName={userName + ' - Energy Profile Report-' + createdAt}
              author="Pitstop Consultancy Pvt. Lts. Team"
              landscape={false}
            >
              <EnergyAudit userName={userName} createdAt={createdAt} />
              {/* <ScoringLogic /> */}
              <DimensionScores scoreAllList={scoreAllList} userName={userName} createdAt={createdAt} />
              <RadarChart scoreAllList={scoreAllList} userName={userName} createdAt={createdAt} />
              <BurnoutRed scoreAllList={scoreAllList} userName={userName} createdAt={createdAt} />
              <PersonalAction scoreAllList={scoreAllList} userName={userName} createdAt={createdAt} />

            </PDFExport>
          </div>
        </div>
      </DashboardUserLayout>
    );
  }
}

function mapStateToProps(state) {
  //console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { questions, users, assessment } = state;
  return {
    loggingIn,
    questions,
    users,
    assessment
  };
}

export default connect(mapStateToProps)(EnergyProfileReport);